import { UserMenu } from '@/apis/types/userMgr';
import { staticMenus } from '@/router/menus';
import onlinePinnedMenu from './onlinePinnedMenu';
import { cloneDeep } from 'lodash-es';
import { useI18n } from '@/hooks/web/useI18n';
// import { LOCALE } from '@/settings/localeSettings';
import { isOnline } from '@/utils/auth';

const { t } = useI18n();
export const PERMISSION_ACCESS_MANAGEMENT = 'ACCESS_PERMISSION_MANAGEMENT';
export const PERMISSION_PHONE_CALL_ELEVATOR = 'WECHAT_CALL_MANAGEMENT';

export type MenuInfo = {
  userMenus: UserMenu[];
  isRemoteUser: boolean;
};

export const filterRoutesFun = (userInfo: MenuInfo) => {
  let userMenuKeys = userInfo.userMenus
    .map((menu) => menu.menuKey)
    .filter((key) => key && key.length > 0);

  if (isOnline()) {
    userMenuKeys = userMenuKeys.filter((e) => e !== 'kol:phoneCallElevatorIntro');
    if (userMenuKeys.includes('ProductIntroduce')) {
      userMenuKeys = userMenuKeys.filter((e) => e !== 'ProductIntroduce' && e !== 'kol:online');
    }
    if (
      !userMenuKeys.includes('kedex:access:manage') &&
      !userMenuKeys.includes(PERMISSION_PHONE_CALL_ELEVATOR)
    ) {
      userMenuKeys = userMenuKeys.filter((e) => e !== 'ACCESS_PERMISSION_MANAGEMENT');
    }
  }

  const menuKeys = fullOrderMenu.filter((key) => userMenuKeys.includes(key));
  // FIXME: 暂时测试
  const existMenuKeys = menuKeys.filter(
    (e) =>
      e == 'kedex:access:manage' ||
      e == 'kedex:multimedia:publish:manage' ||
      (isOnline() && (e == 'KONE_ONLINE_EVENT' || e == 'KONE_ONLINE_EQUIPMENT_PROJECT')) ||
      (isOnline() && e == PERMISSION_PHONE_CALL_ELEVATOR)
  );
  if (existMenuKeys.length > 1) {
    if (
      !(
        existMenuKeys.length == 2 &&
        existMenuKeys.includes('KONE_ONLINE_EVENT') &&
        existMenuKeys.includes('KONE_ONLINE_EQUIPMENT_PROJECT')
      )
    ) {
      menuKeys.unshift('home');
    }
  }
  if (import.meta.env.MODE === 'web') {
    menuKeys.push('escalatorLive');
  }

  console.debug('======UserMenuKeys======', menuKeys);
  // 特殊处理AMP2.0
  // menuKeys.splice(
  //   4,
  //   0,
  //   'kedex:amp2',
  //   'kedex:amp2:dashboard2',
  //   'kedex:amp2:projectSetting2',
  //   'kedex:amp2:systemSetting2'
  // );

  const menuCopy = cloneDeep(staticMenus);
  // 中文使用接口返回的菜单名称
  // const usePermissionAPIName = localStorage.getItem('locale') === LOCALE.ZH_CN;
  // 路由过滤递归函数
  const sorted = menuCopy.sort((a, b) => {
    if (a.meta?.perCode && b.meta?.perCode) {
      const indexA = menuKeys.indexOf(a.meta?.perCode);
      const indexB = menuKeys.indexOf(b.meta?.perCode);
      const posA = indexA === -1 ? menuKeys.length : indexA;
      const posB = indexB === -1 ? menuKeys.length : indexB;
      return posA - posB;
    } else return 0;
  });

  return sorted
    .filter((item) => menuKeys.includes(item.meta?.perCode))
    .filter((item) => !item.meta?.hideMenu)
    .map((item) => {
      // if (usePermissionAPIName) {
      //   resetMenuName(userInfo.userMenus, item, menuKeys)
      // }
      if (item.children) {
        item.children = filterChildrenRoutesFun(userInfo, item.children, menuKeys);
      }

      return item;
    });
};

const filterChildrenRoutesFun = (userInfo: MenuInfo, arr, menuKeys) => {
  return arr
    .filter((item) => {
      return item.meta?.perCode && menuKeys.includes(item.meta?.perCode);
    })
    .filter((item) => {
      if (menuKeys) {
        // if (usePermissionAPIName) {
        //   resetMenuName(userInfo.userMenus, item, menuKeys)
        // }
        const perCode = item.meta.perCode;
        if (menuKeys.includes(perCode)) {
          //项目列表与数字化维保-产品介绍互斥
          if (perCode === 'ProductIntroduce' && userInfo.isRemoteUser) {
            return !menuKeys.includes('KONE_ONLINE_EQUIPMENT_PROJECT');
          }
          //KOL手机用户管理和介绍页互斥
          if (perCode === 'kol:phoneCallElevatorIntro') {
            return !menuKeys.includes(PERMISSION_PHONE_CALL_ELEVATOR);
          }
          return true;
        } else return false;
      } else return true;
    });
};

// const resetMenuName = (userMenus, item, keys) => {
//   const menuKeys = keys as string[];
//   if (menuKeys.includes(item.meta.perCode)) {
//     const findName = userMenus.find(
//       (menu) => menu.menuKey?.toLowerCase() === item.meta.perCode.toLowerCase()
//     )?.menuName;
//     if (findName) {
//       if (item.meta) {
//         item.meta.title = findName;
//       }
//     }
//   }
// };

//云端菜单特殊处理
export function specialMenuOnline(isRemoteAdmin: boolean, menuData: UserMenu[]) {
  const keys = menuData.map((item) => item.menuKey);
  //通行权限管理和系统设置，判断是否有相应子菜单，有则默认父菜单存在
  if (!keys.includes(PERMISSION_ACCESS_MANAGEMENT)) {
    const index1 = keys.indexOf('kedex:access:manage');
    const index2 = keys.indexOf(PERMISSION_PHONE_CALL_ELEVATOR);
    const findIndex = [index1, index2].filter((item) => item > 0);
    if (findIndex.length > 0) {
      menuData.splice(Math.min(...findIndex), 0, {
        menuName: t('router.accessPermissionManagement'),
        menuKey: PERMISSION_ACCESS_MANAGEMENT
      });
    }
  }
  if (import.meta.env.MODE === 'web') {
    if (!keys.includes('kedex:system:settings')) {
      const index1 = keys.indexOf('kedex:system:settings:basic:configuration');
      const index2 = keys.indexOf('kedex:system:settings:data:logs');
      const index3 = keys.indexOf('kedex:system:settings:account:management');
      const findIndex2 = [index1, index2, index3].filter((item) => item > 0);
      if (findIndex2.length > 0) {
        menuData.splice(Math.min(...findIndex2), 0, {
          menuName: t('router.systemSetting'),
          menuKey: 'kedex:system:settings'
        });
      }
    }
  } else {
    if (!keys.includes('SYSTEM_SETTINGS')) {
      const index1 = keys.indexOf('kedex:basic:configuration');
      const index2 = keys.indexOf('DATA_AND_SYSTEM_LOGS');
      const index3 = keys.indexOf('AccountManagement');
      const findIndex2 = [index1, index2, index3].filter((item) => item > 0);
      if (findIndex2.length > 0) {
        menuData.splice(Math.min(...findIndex2), 0, {
          menuName: t('router.systemSetting'),
          menuKey: 'SYSTEM_SETTINGS'
        });
      }
    }
  }

  if (!keys.includes('KONE_ONLINE_EQUIPMENT_PROJECT')) {
    menuData.push({
      menuName: t('router.productIntroduce'),
      menuKey: 'ProductIntroduce'
    });
  } else {
    menuData = menuData.filter((item) => item.menuKey && item.menuKey != 'ProductIntroduce');
  }
  if (isRemoteAdmin) {
    menuData.push(...onlinePinnedMenu);
  } else {
    if (import.meta.env.MODE === 'web') {
      menuData = menuData.filter((item) => item.menuKey && item.menuKey != 'kedex:system:settings');
    } else {
      menuData = menuData.filter((item) => item.menuKey && item.menuKey != 'SYSTEM_SETTINGS');
    }
  }
  //去重
  menuData = Array.from(new Map(menuData.map((item) => [item.menuKey, item])).values());

  return menuData;
}

// 正确顺序的完整菜单权限码
export const fullOrderMenu = [
  'kedex:amp2',
  'kedex:amp2:dashboard2',
  'kedex:amp2:projectSetting2',
  'kedex:amp2:systemSetting2',
  'kedex:amp2:simulationManager',
  'kedex:amp2:equipmentList',
  'kedex:amp2:accountMangement',
  'kedex:amp2:systemSetting2:templateResidualLIfe',
  'kedex:amp2:systemSetting2:projectResidualLife',
  'kedex:mybuilding',
  'kedex:mybuilding:insight',
  'kedex:mybuilding:view',
  'kedex:escalator:monitoring', //本地设备监控
  'kedex:escalator:monitoring:overview', //监控总览
  'kedex:escalator:monitoring:history', //历史与报表
  'kedex:escalator:monitoring:amp', //历史与报表
  PERMISSION_ACCESS_MANAGEMENT, //通行权限管理
  'kedex:access:manage', //IC卡管理
  PERMISSION_PHONE_CALL_ELEVATOR, //手机用户管理
  'kol:phoneCallElevatorIntro', //手机用户管理-功能介绍页
  'kedex:multimedia:manage', //多媒体管理
  'kedex:multimedia:manage:program:publish', //快速发布
  'kedex:multimedia:publish:manage', //发布管理
  'kedex:multimedia:resource:manage', //素材管理
  'kedex:multimedia:manage:program', //节目管理
  'kedex:multimedia:manage:system', //终端设置
  'kol:online', //数字化维保管理
  'KONE_ONLINE_EQUIPMENT_PROJECT', //项目列表
  'KONE_ONLINE_EVENT', //工单与事件
  'ProductIntroduce', //数字化维保管理-产品介绍页
  'kedex:system:settings', //系统设置
  'kedex:system:settings:basic:configuration', //项目基础信息配置
  'kedex:system:settings:data:logs', // 数据与系统日志
  'kedex:system:settings:account:management', //账户管理
  'KONE_ONLINE_JUNIOR_ACCOUNT', //子账号管理
  'SYSTEM_SETTINGS', //系统设置
  'kedex:basic:configuration', //项目基础信息配置
  'DATA_AND_SYSTEM_LOGS', // 数据与系统日志
  'AccountManagement' //账户管理
];
